/**
 * MusicLibraryPage - 新しい音楽画面のトップ（Apple Music のライブラリ相当）
 *
 * 既存の /p?domain=apple_music, /custom-music とは独立した新規画面。
 * 未実装のセクションは非活性で表示する。
 */

import { CircleArrowDown, ListMusic, MicVocal, Music } from 'lucide-react'
import { useNavigate } from 'react-router'

import { Header } from '@/components/shared/header'
import { PATHS } from '@/routes/paths'

import { type LibrarySection, LibrarySectionList } from './library-list'

const LIBRARY_SECTIONS: LibrarySection[] = [
  { key: 'playlists', label: 'プレイリスト', Icon: ListMusic, path: PATHS.MUSIC.PLAYLISTS },
  { key: 'artists', label: 'アーティスト', Icon: MicVocal, path: PATHS.MUSIC.ARTISTS },
  { key: 'songs', label: '曲', Icon: Music, path: PATHS.MUSIC.SONGS },
  { key: 'downloaded', label: 'ダウンロード済み', Icon: CircleArrowDown, path: PATHS.MUSIC.DOWNLOADED },
]

export const MusicLibraryPage = () => {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <Header title="ライブラリ" onClose={() => navigate(PATHS.HOME)} />

      <LibrarySectionList sections={LIBRARY_SECTIONS} ariaLabel="ライブラリ" />
    </div>
  )
}
